import { ExternalView } from "@bitwarden/web-vault/app/models/view/external.view";

export class StorageView extends ExternalView {
  limit: number;
  s3InUsed: number; // cabinet storage usage in MB
  vaultInUsed: number; // vault storage usage in MB
  totalInUsed: number; // total storage usage in MB
  usedRatio: number; // ratio of used storage to limit

  constructor(data: Pick<StorageView, "limit"> & Partial<StorageView>) {
    super();
    this.limit = data.limit;
    this.s3InUsed = data.s3InUsed || 0;
    this.vaultInUsed = data.vaultInUsed || 0;
    this.totalInUsed = this.s3InUsed + this.vaultInUsed;
    this.usedRatio = this.limit ? this.totalInUsed / this.limit : 0;
  }
}
